import {
  useEffect,
  useState,
} from "react";

import {
  criarPacote,
  editarPacote,
  loadPacoteAtivo,
  loadPacotesAluno,
  pagarPacote,
} from "../turmas.service";

import type {
  FormaPagamentoAula,
  PacoteAulas,
} from "../turmas.service";

import type {
  Aluno,
} from "../types";

import "./PacoteAluno.css";


type PacoteAlunoProps = {
  aluno: Aluno;

  turmaId: string;

  canManage: boolean;

  refreshKey?: number;

  onPacoteChange?: () => void;
};


function formatBRL(
  value: number,
) {
  return new Intl.NumberFormat(
    "pt-BR",
    {
      style: "currency",
      currency: "BRL",
    },
  ).format(value);
}


export default function PacoteAluno({
  aluno,
  turmaId,
  canManage,
  refreshKey = 0,
  onPacoteChange,
}: PacoteAlunoProps) {
  const [
    pacote,
    setPacote,
  ] =
    useState<PacoteAulas | null>(
      null,
    );
    const [
  receiving,
  setReceiving,
] =
  useState(false);


const [
  showPayment,
  setShowPayment,
] =
  useState(false);


  const [
    loading,
    setLoading,
  ] =
    useState(true);

    const [
  pacotesHistorico,
  setPacotesHistorico,
] =
  useState<PacoteAulas[]>([]);


const [
  showHistorico,
  setShowHistorico,
] =
  useState(false);


  const [
    saving,
    setSaving,
  ] =
    useState(false);


  const [
    editing,
    setEditing,
  ] =
    useState(false);


  const [
    error,
    setError,
  ] =
    useState("");


  const [
    quantidade,
    setQuantidade,
  ] =
    useState(8);


  const [
    valor,
    setValor,
  ] =
    useState("");


  useEffect(() => {
    let active =
      true;


    async function load() {
      try {
        setLoading(
          true,
        );

        const result =
          await loadPacoteAtivo(
            aluno.id,
            turmaId,
          );


        if (!active) {
          return;
        }
        const historico =
  await loadPacotesAluno(
    aluno.id,
    turmaId,
  );


        setPacote(
          result,
        );
        setPacotesHistorico(
  historico,
);

        if (result) {
          setQuantidade(
            result.quantidade_aulas,
          );

          setValor(
            String(
              result.valor,
            ),
          );
        }

        setError("");
      } catch (err) {
        console.error(
          err,
        );

        if (active) {
          setError(
            "Não foi possível carregar o pacote.",
          );
        }
      } finally {
        if (active) {
          setLoading(
            false,
          );
        }
      }
    }


    load();


    return () => {
      active =
        false;
    };
  }, [
  aluno.id,
  turmaId,
  refreshKey,
]);


  function openForm() {
    if (pacote) {
      setQuantidade(
        pacote.quantidade_aulas,
      );

      setValor(
        String(
          pacote.valor,
        ),
      );
    } else {
  const ultimoPacote =
    pacotesHistorico[0];


  if (ultimoPacote) {
    setQuantidade(
      ultimoPacote.quantidade_aulas,
    );

    setValor(
      String(
        ultimoPacote.valor,
      ),
    );
  } else {
    setQuantidade(8);

    setValor("");
  }
}


    setError("");

    setEditing(
      true,
    );
  }


  function closeForm() {
    if (saving) {
      return;
    }

    setEditing(
      false,
    );

    setError("");
  }


  async function handleSave() {
    const numericValue =
      Number(
        valor
          .replace(",", "."),
      );


    if (
      quantidade <=
      0
    ) {
      setError(
        "Informe uma quantidade válida de aulas.",
      );

      return;
    }


    if (
      Number.isNaN(
        numericValue,
      ) ||
      numericValue < 0
    ) {
      setError(
        "Informe um valor válido para o pacote.",
      );

      return;
    }


    try {
      setSaving(
        true,
      );

      setError("");


      const result =
        pacote
          ? await editarPacote(
              pacote.id,
              quantidade,
              numericValue,
            )
          : await criarPacote(
              aluno.id,
              turmaId,
              quantidade,
              numericValue,
            );


      setPacote(
        result,
      );

      setQuantidade(
        result.quantidade_aulas,
      );

      setValor(
        String(
          result.valor,
        ),
      );

      setEditing(
        false,
      );
      setShowPayment(
  false,
);
onPacoteChange?.();
    } catch (err) {
      console.error(
        err,
      );

      setError(
        err instanceof Error
          ? err.message
          : "Não foi possível salvar o pacote.",
      );
    } finally {
      setSaving(
        false,
      );
    }
  }
  async function handleReceive(
  formaPagamento:
    FormaPagamentoAula,
) {
  if (
    !pacote ||
    pacote.pago
  ) {
    return;
  }


  try {
    setReceiving(
      true,
    );

    setError("");


    const result =
      await pagarPacote(
        pacote.id,
        formaPagamento,
      );


    setPacote(
      (current) =>
        current
          ? {
              ...current,

              pago:
                true,

              forma_pagamento:
                result.forma_pagamento,

              pago_em:
                result.pago_em,
            }
          : current,
    );


    setShowPayment(
      false,
    );
  } catch (err) {
    console.error(
      err,
    );

    setError(
      err instanceof Error
        ? err.message
        : "Não foi possível receber o pacote.",
    );
  } finally {
    setReceiving(
      false,
    );
  }
}


  if (loading) {
    return (
      <div className="pacote-aluno-loading">
        Carregando pacote...
      </div>
    );
  }


  const usadas =
    pacote?.aulas_usadas ??
    0;


  const total =
    pacote?.quantidade_aulas ??
    0;


  const restantes =
    Math.max(
      total - usadas,
      0,
    );

    const pacotesAnteriores =
  pacotesHistorico.filter(
    (item) =>
      item.id !==
      pacote?.id,
  );


  return (
    <div className="pacote-aluno">
      {!pacote ? (
        <div className="pacote-aluno-empty">
          <div>
  <span>
    PACOTE
  </span>

  <strong>
    Nenhum pacote ativo
  </strong>

  {pacotesAnteriores.length > 0 && (
    <small>
      O último pacote foi encerrado.
    </small>
  )}
</div>


{canManage && (
  <button
    type="button"
    onClick={
      openForm
    }
  >
    {pacotesAnteriores.length > 0
      ? "Renovar pacote"
      : "+ Criar pacote"}
  </button>
)}
        </div>
      ) : (
        <>
          <div className="pacote-aluno-header">
            <div>
              <span>
                PACOTE ATUAL
              </span>

              <strong>
                {pacote.quantidade_aulas} aulas
              </strong>
            </div>


            <div
              className={
                pacote.pago
                  ? "pacote-status pacote-status-paid"
                  : "pacote-status pacote-status-pending"
              }
            >
              {pacote.pago
                ? "Pago"
                : "Pendente"}
            </div>
          </div>


          <div className="pacote-aluno-stats">
            <div>
              <span>
                Usadas
              </span>

              <strong>
                {usadas}
              </strong>
            </div>

            <div>
              <span>
                Restantes
              </span>

              <strong>
                {restantes}
              </strong>
            </div>

            <div>
              <span>
                Valor
              </span>

              <strong>
                {formatBRL(
                  pacote.valor,
                )}
              </strong>
            </div>
          </div>


          <div className="pacote-progress">
            <div
              className="pacote-progress-bar"
              style={{
                width:
                  total > 0
                    ? `${Math.min(
                        100,
                        (
                          usadas /
                          total
                        ) *
                          100,
                      )}%`
                    : "0%",
              }}
            />
          </div>


          <div className="pacote-progress-label">
  {usadas} de{" "}
  {total} aulas utilizadas
</div>


{pacote &&
  restantes <= 2 &&
  restantes > 0 && (
  <div className="pacote-warning">
    {restantes === 1
      ? "⚠ Última aula disponível neste pacote."
      : "⚠ Este pacote está próximo do fim."}
  </div>
)}


          {canManage && (
  <div className="pacote-actions">
    {!pacote.pago && (
      <button
        type="button"
        className="pacote-receive-button"
        onClick={() =>
          setShowPayment(
            (current) =>
              !current,
          )
        }
        disabled={
          receiving
        }
      >
        {receiving
          ? "Recebendo..."
          : "Receber pacote"}
      </button>
    )}

   
    <button
  type="button"
  className="pacote-edit-button"
  onClick={
    openForm
  }
  disabled={
    receiving ||
    pacote.pago
  }
>
  {pacote.pago
    ? "Pacote recebido"
    : "Editar pacote"}
</button>
  </div>
)}

{pacotesAnteriores.length > 0 && (
  <>
    <button
      type="button"
      className="pacote-history-toggle"
      onClick={() =>
        setShowHistorico(
          (current) =>
            !current,
        )
      }
    >
      {showHistorico
        ? "Ocultar pacotes anteriores"
        : `Ver pacotes anteriores (${pacotesAnteriores.length})`}
    </button>


    {showHistorico && (
      <div className="pacote-history-list">
        {pacotesAnteriores.map(
          (item) => {
            const restantesHistorico =
              Math.max(
                item.quantidade_aulas -
                  item.aulas_usadas,
                0,
              );


            return (
              <div
                key={
                  item.id
                }
                className="pacote-history-card"
              >
                <div>
                  <strong>
                    {item.quantidade_aulas} aulas
                  </strong>

                  <span>
                    {item.aulas_usadas} usadas
                    {" • "}
                    {restantesHistorico} restantes
                  </span>
                </div>

                <div>
                  <strong>
                    {formatBRL(
                      item.valor,
                    )}
                  </strong>

                  <span>
                    {item.status}
                    {" • "}
                    {item.pago
                      ? `Pago${
                          item.forma_pagamento
                            ? ` via ${item.forma_pagamento}`
                            : ""
                        }`
                      : "Pendente"}
                  </span>
                </div>
              </div>
            );
          },
        )}
      </div>
    )}
  </>
)}

{showPayment &&
  !pacote.pago && (
  <div className="pacote-payment">
    <span>
      Forma de pagamento
    </span>

    <div className="pacote-payment-options">
      <button
        type="button"
        onClick={() =>
          handleReceive(
            "pix",
          )
        }
        disabled={
          receiving
        }
      >
        Pix
      </button>

      <button
        type="button"
        onClick={() =>
          handleReceive(
            "dinheiro",
          )
        }
        disabled={
          receiving
        }
      >
        Dinheiro
      </button>

      <button
        type="button"
        onClick={() =>
          handleReceive(
            "debito",
          )
        }
        disabled={
          receiving
        }
      >
        Débito
      </button>

      <button
        type="button"
        onClick={() =>
          handleReceive(
            "credito",
          )
        }
        disabled={
          receiving
        }
      >
        Crédito
      </button>
    </div>
  </div>
)}
        </>
      )}


      {editing && (
        <div className="pacote-form">
          <div className="pacote-form-title">
            {pacote
  ? "Editar pacote"
  : pacotesAnteriores.length > 0
    ? "Renovar pacote"
    : "Novo pacote"}
          </div>


          <label>
            Quantidade de aulas

            <input
              type="number"
              min={
                pacote?.aulas_usadas ??
                1
              }
              value={
                quantidade
              }
              onChange={(
                event,
              ) =>
                setQuantidade(
                  Math.max(
                    1,
                    Number(
                      event.target
                        .value,
                    ),
                  ),
                )
              }
            />
          </label>


          <label>
            Valor combinado

            <input
              type="text"
              inputMode="decimal"
              value={
                valor
              }
              onChange={(
                event,
              ) =>
                setValor(
                  event.target
                    .value,
                )
              }
              placeholder="Ex.: 240,00"
            />
          </label>


          {error && (
            <div className="pacote-error">
              {error}
            </div>
          )}


          <div className="pacote-form-actions">
            <button
              type="button"
              className="pacote-cancel"
              onClick={
                closeForm
              }
              disabled={
                saving
              }
            >
              Cancelar
            </button>

            <button
              type="button"
              className="pacote-save"
              onClick={
                handleSave
              }
              disabled={
                saving
              }
            >
              {saving
                ? "Salvando..."
                : "Salvar pacote"}
            </button>
          </div>
        </div>
      )}


      {!editing &&
        error && (
          <div className="pacote-error">
            {error}
          </div>
        )}
    </div>
  );
}